// extracted by mini-css-extract-plugin
export default {"content":"AccountDestiny_content__Cj5v6","bank":"AccountDestiny_bank__14dhf","fields":"AccountDestiny_fields__ssfYy","one":"AccountDestiny_one__5817Z"};